export default {

	/***********Local Server Start*****************/
	//  api_url: 'http://localhost:3000/', //// Localhost
	//  crmivr_url: 'http://xbivr.xbees.in:91/', // Live CRM IVR Portal
	//  user_tracker: 'http://stageiptracking.xbees.in/api/', // Staging User Tracker server
	//  cargo_url: 'http://cargoautoallocation-appstage.xbees.in/#/login', // Cargo Extra Charges
	//  EMAILR_CONFIG_DATA : [{
	// 	EMAILR_CONFIG_ID : 1,
	// 	EMAILR_ACK_EMAIL : 'xbdev.testing@xpressbees.com'
	// 	},{
	// 	EMAILR_CONFIG_ID : 3,
	// 	EMAILR_ACK_EMAIL : 'xbtestfeedback@xpressbees.in'
	//   }
	// ],
	// ums_url:'http://stageusermanagement.xbees.in/#/forgotpassword',
		/***********End Local Server*****************/

	/***********Stage Server Start*****************/
	 /*
	api_url: 'http://clt-crm-api.xbees.in/', // Staging API server
	crmivr_url: 'http://xbivr.xbees.in:91/', // Live CRM IVR Portal
	user_tracker: 'http://stageiptracking.xbees.in/api/', // Staging User Tracker server
	cargo_url: 'http://cargoautoallocation-appstage.xbees.in/#/login', // Cargo Extra Charges
	EMAILR_CONFIG_DATA: [{
		EMAILR_CONFIG_ID: 1,
		EMAILR_ACK_EMAIL: 'xbdev.testing@xpressbees.com'
	}, {
		EMAILR_CONFIG_ID: 3,
		EMAILR_ACK_EMAIL: 'xbtestfeedback@xpressbees.in'
	}],
	 ums_url:'http://stageusermanagement.xbees.in/#/forgotpassword',
	*/
	/***********End Stage Server*****************/

	/***********Live Server Start*****************/
	// api_url: 'http://internal-INTERNAL-CLT-CRM-API-LIVE-1031224131.ap-south-1.elb.amazonaws.com/', // Live API server
	api_url: 'https://xbcrmapi.xbees.in/', // Live API server
	crmivr_url: 'https://xbivrwebrtc.xbees.in/', // Live CRM IVR Portal
	user_tracker: 'https://track.xbees.in/api/', // Live User Tracker server
	cargo_url: 'https://b2bapp.xbees.in/#/login', // Cargo Extra Charges
	EMAILR_CONFIG_DATA : [{
	 	EMAILR_CONFIG_ID : 1,
	 	EMAILR_ACK_EMAIL : 'customercare@xpressbees.com'
	 	},{
	 	EMAILR_CONFIG_ID : 3,
	 	EMAILR_ACK_EMAIL : 'wallet.support@xpressbees.com'
	   }
	],
	ums_url:'https://userauthentication.xbees.in',
	url_scheduler :'https://xbcrmliveapi1.xbees.in/',
	kavach_url:'https://auth.xbees.in',
	authservice_url:'https://authservice.xbees.in/',
	/***********End Live Server*****************/

	project_name: 'CLT CRM',
}



// WEBPACK FOOTER //
// ./src/constants.js